import React from 'react';
import {v4 as uuidv4} from "uuid";
import ComponentHeader from "./ComponentHeader";
import TextComponent from "../input/TextComponent";

class ContentTextComponent extends TextComponent {
    constructor(props) {
        super(props);
        this.onLoadingFinished = props.onLoadingFinished;
        this.component = props.component;
    }

    static create(){
        return {
                id: uuidv4(),
                type : "text",
                description: "",
                title: "Text-Block",
                data : {},
                config: {
                    comments: []
                }
            }
    }

    componentDidMount() {
        this.onLoadingFinished(this.component);
    }

    renderEditorView(){
        return (
            <div>
            </div>
        );
    }

    renderInputView(){
        return (
            <div className={this.component.type}>

            </div>
        );
    }

    renderInstructorView(){
        return (
            <div className={this.component.type}>

            </div>
        );
    }

    render() {
        if(this.props.instructorMode){
            return <div>
                {/*JSON.stringify(this.component)*/}
                {this.renderInstructorView()}
            </div>
        } else if(this.props.showEditorView){
            return <div>
                {/*JSON.stringify(this.component)*/}
                {this.renderEditorView()}
            </div>
        }else{
            return <div>
                {/*JSON.stringify(this.component)*/}
                {this.renderInputView(this.instructorMode)}
            </div>
        }
    }
}
export default ContentTextComponent;